module.exports = __webpack_public_path__ + "img/icon-oderlist.246b4de7.png";